import type { Account, Order, Product, RegisterPayload, ShippingMeta, User } from "~/types";
import { PRODUCTS } from "~/data/products";
import { ORDERS } from "~/data/orders";
import { ACCOUNT } from "~/data/account";

const MOCKS_ONLY = String(import.meta.env.VITE_MOCKS_ONLY ?? "true") !== "false";
const API_BASE = (import.meta.env.VITE_API_BASE ?? "") as string;

const MOCK_USER: User = {
  id: "u-1",
  name: "Олена Шевченко",
  email: "olena@brand.coffee",
  role: "Власник закладу",
};

class ApiError extends Error {
  constructor(public status: number, message: string) { super(message); }
}

async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(API_BASE + path, {
    ...init,
    headers: { "content-type": "application/json", ...(init?.headers ?? {}) },
    credentials: "include",
  });
  if (!res.ok) throw new ApiError(res.status, await res.text());
  return res.json() as Promise<T>;
}

function makeMockOrder(payload: { items: { p: string; q: number }[]; shipping: ShippingMeta; subtotal: number; shippingCost: number }): Order {
  const id = `FND-${String(10500 + Math.floor(Math.random() * 500)).padStart(5, "0")}`;
  const now = new Date().toISOString().slice(0, 10);
  return {
    id,
    date: now,
    status: "processing",
    paymentStatus: "unpaid",
    shipping: payload.shipping,
    items: payload.items,
    subtotal: payload.subtotal,
    shippingCost: payload.shippingCost,
    total: payload.subtotal + payload.shippingCost,
    timeline: [{ stage: "processing", at: now }],
  };
}

export const api = {
  products: (): Promise<Product[]> =>
    MOCKS_ONLY ? Promise.resolve(PRODUCTS) : fetchJson("/api/products"),
  orders: (): Promise<Order[]> =>
    MOCKS_ONLY ? Promise.resolve(ORDERS) : fetchJson("/api/orders"),
  account: (): Promise<Account> =>
    MOCKS_ONLY ? Promise.resolve(ACCOUNT) : fetchJson("/api/account"),
  login: (email: string, _password: string): Promise<{ user: User }> =>
    MOCKS_ONLY ? Promise.resolve({ user: { ...MOCK_USER, email } }) : fetchJson("/api/auth/login", { method: "POST", body: JSON.stringify({ email, password: _password }) }),
  loginMagic: (email: string): Promise<{ ok: true }> =>
    MOCKS_ONLY ? Promise.resolve({ ok: true }) : fetchJson("/api/auth/magic", { method: "POST", body: JSON.stringify({ email }) }),
  register: (payload: RegisterPayload): Promise<{ ok: true }> =>
    MOCKS_ONLY ? Promise.resolve({ ok: true }) : fetchJson("/api/auth/register", { method: "POST", body: JSON.stringify(payload) }),
  createOrder: (payload: Parameters<typeof makeMockOrder>[0]): Promise<Order> =>
    MOCKS_ONLY ? Promise.resolve(makeMockOrder(payload)) : fetchJson("/api/orders", { method: "POST", body: JSON.stringify(payload) }),
};
